import { ContainerBoxInterface } from '@peakconcepts/landingpage-kit'
import colors from '../../default/colors'

const data: ContainerBoxInterface = {
  containers: [
    {
      classNames: 'container',
      padding: {
        fullHd: '80px 0',
        widescreen: '80px 0',
        desktop: '80px 40px',
        tablet: '60px 40px',
        mobile: '40px 20px'
      },
      containers: [
        {
          classNames: 'columns is-multiline',
          containers: [
            {
              classNames: 'column is-full',
              defaultCss: {
                background: colors.primary
              },
              padding: {
                fullHd: '80px 0',
                widescreen: '80px 0',
                desktop: '80px 40px',
                tablet: '60px 40px',
                mobile: '40px 20px'
              },
              containers: [
                {
                  type: 'text',
                  config: {
                    size: 2,
                    fontSize: {
                      desktop: '54px',
                      tablet: '48px',
                      mobile: '20px'
                    },
                    margin: { desktop: '0', tablet: '0', mobile: '0 0 10px' },
                    defaultCss: {
                      color: '#fff'
                    },
                    text: 'Herzlichen Glückwunsch!'
                  }
                },
                {
                  type: 'text',
                  config: {
                    size: 2,
                    fontSize: {
                      desktop: '32px',
                      tablet: '24px',
                      mobile: '16px'
                    },
                    margin: {
                      desktop: '0 0 30px',
                      tablet: '0 0 30px',
                      mobile: '0 0 30px'
                    },
                    defaultCss: {
                      color: '#fff'
                    },
                    text: 'Ihre Anfrage war erfolgreich ✅'
                  }
                },
                {
                  type: 'text',
                  config: {
                    fontSize: {
                      desktop: '20px',
                      tablet: '20px',
                      mobile: '16px'
                    },
                    margin: { desktop: '0', tablet: '0', mobile: '0' },
                    defaultCss: {
                      textAlign: 'center',
                      color: '#fff'
                    },
                    text:
                      'An dieser Stelle möchte ich mich für Ihr Vertrauen bedanken!'
                  }
                }
              ]
            },
            {
              classNames: 'column is-full',
              padding: {
                desktop: '80px 40px',
                tablet: '60px 30px',
                mobile: '40px 15px'
              },
              defaultCss: {
                boxShadow: '0 1px 5px rgb(0 0 0 / 20%)',
                media: [
                  {
                    breakpoint: 'mobile',
                    css: { boxShadow: 'none' }
                  }
                ]
              },
              containers: [
                {
                  type: 'text',
                  config: {
                    size: 2,
                    text: 'Wie geht es jetzt weiter?'
                  }
                },
                {
                  type: 'text',
                  config: {
                    fontSize: {
                      desktop: '20px',
                      tablet: '20px',
                      mobile: '18px'
                    },
                    margin: {
                      desktop: '0 200px 40px',
                      tablet: '0',
                      mobile: '0'
                    },
                    defaultCss: {
                      textAlign: 'center'
                    },
                    text:
                      'Sie bekommen die Möglichkeit zu <u>100% kostenlos</u> all Ihre Fragen zu stellen und sich genau über die Zusammenarbeit mit mir zu informieren.<br/><br/> Um Ihnen Ihre Fragen so gut wie möglich beantworten zu können, erhalten Sie zum vereinbarten Termin einen Anruf. <br/><br/> In unserem Erstgespräch nehme ich mir exklusiv Zeit für Sie und gehe <b>individuell</b> auf Ihre Situation ein.<br/><br/><br/><b>Ich freue mich auf Sie.</b><br/><br/><br/>Viele Grüße <br/>Julia Beuther'
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}

export default data
